import styled from "styled-components"

export const Gap = styled.span<{ height: number }>`
  height: ${({ height }) => height}px;

  @media only screen and (max-width: 768px) {
    height: ${({ height }) => height / 2}px;
  }
`
